import { Row } from '@/components/Row';
import { LabradorComponent } from '@/types/component';
import { cn } from '@/utils/cn';
import { getChildrenCount } from '@/utils/getChildrenCount';
import { getViewportVisibilityClass } from '@/utils/getViewportVisibilityClass';
import { mergeOptions } from '@/utils/merge';
import { withBackgroundColor } from '@/utils/withBackgroundColor';
import { withTextAlign } from '@/utils/withTextAlign';
import { renderContentComponent } from 'modules/dynamic/components';
import { Fragment } from 'react';

export const LabradorRow: LabradorComponent = ({ type, data, meta, descendants, options, ...props }) => {
  if (!getChildrenCount(descendants)) {
    return null;
  }

  const backgroundColor = withBackgroundColor(meta.backgroundColor, true);
  const viewportVisibilityClass = getViewportVisibilityClass({
    viewportVisibility: meta.viewportVisibility,
    hideViewport: meta.hideViewport,
  });

  const content = descendants.map((child, index) => {
    return <Fragment key={index}>{renderContentComponent(child)}</Fragment>;
  });

  const contentIndex = meta.contentIndex;
  const rowType = meta.frontRowType;
  const textAlign = withTextAlign(meta.textAlignRowTitle);

  return (
    <Row
      headline={data.title}
      content={content}
      button={data.rowButton}
      options={mergeOptions(
        {
          className: cn(backgroundColor, viewportVisibilityClass),
          $headline: { className: cn(textAlign) },
        },
        options,
      )}
      data-content-index={contentIndex}
      data-row-type={rowType}
      {...props}
    />
  );
};
